import axios from 'axios';

const API_URL =
  import.meta.env.VITE_CRM_API_URL || 'https://dashboard.lono.co.in/api/credit';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const creditAPI = {
  // Fetch credit score for a specific user
  getCreditScore: async (userId) => {
    try {
      const response = await api.get(`/score/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Check loan eligibility for a specific user
  checkLoanEligibility: async (userId, loanDetails) => {
    try {
      const response = await api.post(`/eligibility/${userId}`, loanDetails);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Distribute loan to multiple banks
  distributeLoanToBanks: async (data) => {
    try {
      const response = await api.post('/loan-distribution', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all loan distributions for a loan
  getLoanDistributions: async (loanId) => {
    try {
      const response = await api.get(`/loan/${loanId}/distributions`);
      if (response.data?.success && Array.isArray(response.data.distributions)) {
        return response.data.distributions;
      } else {
        throw new Error(response.data?.message || 'Unexpected response structure when fetching loan distributions.');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to load distribution details';
      throw new Error(errorMessage);
    }
  },

  // Select final banking partner for a loan
  selectFinalBankingPartner: async (loanId, distributionId) => {
    try {
      const response = await api.post(`/loan/${loanId}/select-bank`, { distributionId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get accepted banking partners for a loan
  getAcceptedBankingPartnersByLoan: async (loanId) => {
    try {
      const response = await api.get(`/loan/${loanId}/accepted-partners`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Send loan details (bank offer) to customer and update loan status
  sendLoanDetailsToCustomer: async (loanId, bankOfferDetails) => {
    console.log("creditApi.js: sendLoanDetailsToCustomer called.");
    console.log("creditApi.js: loanId:", loanId, "bankOfferDetails:", bankOfferDetails);
    try {
      const response = await api.post(`/loan/${loanId}/send-to-customer`, bankOfferDetails);
      console.log("creditApi.js: Response from API:", response);
      return response.data;
    } catch (error) {
      console.error("creditApi.js: Error calling sendLoanDetailsToCustomer API:", error.response || error.message);
      throw error.response?.data || error.message;
    }
  }
};